import CancelIcon from '@mui/icons-material/Cancel';
import { CaseResponse, UserAccountResponse } from '../../store/case/model';
import { Ii18n } from '../../store/utils/contracts/i18n.interface';
import React from 'react';
import { getI18n } from '../../store/utils/i18n/strings.manager';
import styles from './assignCaseModal.module.css';
import { Modal, Button, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { assignUserOpen, assignUserClose, assignUser, changeAssignedUserId } from 'src/store/case';

interface Props {
    readonly selectedCase?: CaseResponse;
    readonly showAssignModal: boolean;
    readonly assignableUsers: UserAccountResponse[];
    readonly selectedAssignedUserId: number | '';
    readonly selectedClaimNotificationId: number;
    readonly assignUserOpen: typeof assignUserOpen;
    readonly assignUserClose: typeof assignUserClose;
    readonly assignUser: typeof assignUser;
    readonly changeAssignedUserId: typeof changeAssignedUserId;
}

interface IAssignCaseModal {
    expertName: string;
}

class AssignCaseModal extends React.Component<Props, IAssignCaseModal> {
  private localization: Ii18n;

  constructor(props: Props) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    return (
        <Modal
            aria-labelledby='simple-modal-title'
            aria-describedby='simple-modal-description'
            open={this.props.showAssignModal}
            onClose={() => this.props.assignUserClose()}
        >
        <div className={styles.modal}>
        <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
            <Select
                value={this.props.selectedAssignedUserId ? this.props.selectedAssignedUserId.toString() : ''}
                onChange={(event: SelectChangeEvent<string>) => {
                const selectedUser = this.props.assignableUsers.find(x => x.userId === +event.target.value);
                this.setState({ expertName: selectedUser ? selectedUser.userFullName : '' });
                this.props.changeAssignedUserId(+event.target.value);
                }}
                displayEmpty
                className={styles.select}
            >
                <MenuItem value='' key='' disabled>
                {this.localization.get('home.assignUser.choose')}
                </MenuItem>
                {this.props.assignableUsers.map(x => <MenuItem value={x.userId} key={x.userId}>{x.userFullName}</MenuItem>)}
            </Select>
            </div>
        </div>
        <div className={styles.row}>
            <Button
            variant='contained'
            className={styles.button}
            onClick={() => this.props.assignUserClose()} >
            {this.localization.get('shared.cancel')}
            <CancelIcon className={styles.rightIcon} />
            </Button>
            <Button
            variant='contained'
            color='secondary'
            disabled={this.props.selectedAssignedUserId === ''}
            className={styles.button}
            onClick={() => {
                if (this.props.selectedAssignedUserId) {
                    this.props.assignUser(this.props.selectedAssignedUserId, this.props.selectedClaimNotificationId, this.state.expertName);
                }
            }}
            >
            {this.localization.get('home.assignUser.button')}
            </Button>
        </div>
        </div>
        </Modal>
        );
    }
}

export { AssignCaseModal };
